// Recovered compiled webpack factory 57630. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      INTERCEPTION_ROUTE_MARKERS: function () {
        return a;
      },
      extractInterceptionRouteInformation: function () {
        return i;
      },
      isInterceptionRouteAppPath: function () {
        return o;
      },
    }));
  let n = r(74061),
    a = ["(..)(..)", "(.)", "(..)", "(...)"];
  function o(e) {
    return void 0 !== e.split("/").find((e) => a.find((t) => e.startsWith(t)));
  }
  function i(e) {
    let t, r, o;
    for (let n of e.split("/"))
      if ((r = a.find((e) => n.startsWith(e)))) {
        [t, o] = e.split(r, 2);
        break;
      }
    if (!t || !r || !o)
      throw Object.defineProperty(
        Error(
          "Invalid interception route: " +
            e +
            ". Must be in the format /<intercepting route>/(..|...|..)(..)/<intercepted route>",
        ),
        "__NEXT_ERROR_CODE",
        { value: "E269", enumerable: !1, configurable: !0 },
      );
    switch (((t = (0, n.normalizeAppPath)(t)), r)) {
      case "(.)":
        o = "/" === t ? "/" + o : t + "/" + o;
        break;
      case "(..)":
        if ("/" === t)
          throw Object.defineProperty(
            Error(
              "Invalid interception route: " +
                e +
                ". Cannot use (..) marker at the root level, use (.) instead.",
            ),
            "__NEXT_ERROR_CODE",
            { value: "E207", enumerable: !1, configurable: !0 },
          );
        o = t.split("/").slice(0, -1).concat(o).join("/");
        break;
      case "(...)":
        o = "/" + o;
        break;
      case "(..)(..)":
        let i = t.split("/");
        if (i.length <= 2)
          throw Object.defineProperty(
            Error(
              "Invalid interception route: " +
                e +
                ". Cannot use (..)(..) marker at the root level or one level up.",
            ),
            "__NEXT_ERROR_CODE",
            { value: "E486", enumerable: !1, configurable: !0 },
          );
        o = i.slice(0, -2).concat(o).join("/");
        break;
      default:
        throw Object.defineProperty(Error("Invariant: unexpected marker"), "__NEXT_ERROR_CODE", {
          value: "E112",
          enumerable: !1,
          configurable: !0,
        });
    }
    return { interceptingRoute: t, interceptedRoute: o };
  }
}
